import $ from 'jquery';
window.jQuery = $;
import 'jquery-modal';
import screenSize from '../services/screen_size';
import config from '../config';
import postInfiniteScroll from './post-infinite-scroll';
class MobileBottomInfiniteScrollBar {
    on() {
        this.config = config;
        this.enabled = config.get('featureFlags.postInfiniteScroll');
        if (this.enabled === true && screenSize.getSize() === 'small') {
            this.$container = $('.mobile-bottom-infinite-scroll-bar');
            this.$skip = this.$container.find('.skip');
            this.$more = this.$container.find('.more');
            this.$shareModal = this.$container.find('.share-modal');
            this.moreClick = this.moreClick.bind(this);
            this.skipClick = this.skipClick.bind(this);
            this.$shareModal.on('click', this.shareModalClick);
            this.$more.on('click', this.moreClick);
            this.$skip.on('click', this.skipClick);

            // this.$body = $('body');
            // this.$body.append(`<div class="all-iframe offpage"><iframe src="//all.fastcompany.com"></iframe></div>`);
            //this.$iframeContainer = $('.all-iframe');
            this.hidden = true;
        }
    }

    off() {
        this.$more.off('click', this.moreClick);
        this.$skip.off('click', this.skipClick);
    }

    skipClick() {
        const nextUrl = postInfiniteScroll.getNextPost();
        $('.main').addClass('animated fade-out');
        window.location = `${nextUrl}?utm_source=bottom%20navbar&utm_medium=mobile&utm_campaign=mobile%20bottom%20nav&icid=bottomnav`;
    }

    shareModalClick() {
        $('.share-modal-content').modal({
            closeExisting: true,
            escapeClose: true,
            clickClose: true,
            closeClass: '.close-modal',
            modalClass: 'modal',
            spinnerHtml: null,
            showSpinner: true,
            showClose: true,
            fadeDuration: null,
            fadeDelay: 1.0
        });
    }

    moreClick() {
        /*
         this.hidden = !this.hidden;
         this.$iframeContainer.toggleClass('offpage');
         if (this.hidden === true) {
         this.$body.css({overflow: ''});
         } else {
         this.$body.css({overflow: 'hidden'});
         }
         return this;
         */
        const allUrl = `https://all.fastcompany.com`;
        $('.main').addClass('animated fade-out');
        window.location = allUrl;
    }
}

export default new MobileBottomInfiniteScrollBar();

